// Persists JWT access/refresh tokens and notifies subscribers when the session expires.

const ACCESS_KEY = "easylister.accessToken";
const REFRESH_KEY = "easylister.refreshToken";

// Mirrors the session into the EasyLister Chrome extension's expected key
// (read by its panelBridge content script) so the popup stays signed in too,
// including on silent token refreshes that bypass auth-context entirely.
const EXTENSION_SESSION_KEY = "cde_session";

let expiredListeners = [];

export const getAccessToken = () => localStorage.getItem(ACCESS_KEY);
export const getRefreshToken = () => localStorage.getItem(REFRESH_KEY);

export const setTokens = ({ accessToken, refreshToken } = {}) => {
  if (accessToken) localStorage.setItem(ACCESS_KEY, accessToken);
  if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);

  const nextAccess = accessToken || getAccessToken();
  const nextRefresh = refreshToken || getRefreshToken();
  if (nextAccess && nextRefresh) {
    localStorage.setItem(
      EXTENSION_SESSION_KEY,
      JSON.stringify({ accessToken: nextAccess, refreshToken: nextRefresh }),
    );
  }
};

export const clearTokens = () => {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(EXTENSION_SESSION_KEY);
};

export const onAuthExpired = (listener) => {
  expiredListeners.push(listener);
  return () => {
    expiredListeners = expiredListeners.filter((l) => l !== listener);
  };
};

export const emitAuthExpired = () => {
  expiredListeners.forEach((listener) => listener());
};
